import React, { useEffect, useRef, useState } from "react"
import { Link } from "gatsby"
import { MobileLogo } from "./logoMobile"
import styles from "../styles/components/header.module.scss"

const links = [
  ["Home", "/#home"],
  ["Blog", "/blog/"],
  ["About", "/#about"],
  ["Trainers", "/#team"],
  ["Pricing", "/#pricing"],
  ["Gallery", "/#gallery"],
  ["Contact", "/#contact"],
]

export default function Header() {
  const [open, setOpen] = useState(false)
  const [active, setActive] = useState("")
  const toggle = useRef(null)
  const header = useRef(null)

  useEffect(() => {
    const updateActive = () => {
      if (window.location.pathname !== "/") {
        setActive(
          window.location.pathname.replace(/\/$/, "") === "/blog"
            ? "/blog/"
            : ""
        )
        return
      }
      let current = "/#home"
      links.forEach(([, href]) => {
        if (!href.includes("#")) return
        const section = document.getElementById(href.split("#")[1])
        if (section && section.getBoundingClientRect().top <= 140)
          current = href
      })
      setActive(current)
    }
    const onResize = () => {
      if (window.innerWidth >= 1100) setOpen(false)
    }
    const onPointer = event => {
      if (header.current && !header.current.contains(event.target))
        setOpen(false)
    }
    updateActive()
    window.addEventListener("scroll", updateActive, { passive: true })
    window.addEventListener("resize", onResize)
    document.addEventListener("pointerdown", onPointer)
    return () => {
      window.removeEventListener("scroll", updateActive)
      window.removeEventListener("resize", onResize)
      document.removeEventListener("pointerdown", onPointer)
    }
  }, [])

  return (
    <header
      ref={header}
      className={styles.header}
      onKeyDown={event => {
        if (event.key === "Escape" && open) {
          setOpen(false)
          toggle.current.focus()
        }
      }}
      onBlur={event => {
        if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false)
      }}
    >
      <div className={styles.bar}>
        <Link
          to="/"
          className={styles.logo}
          aria-label="Lifetime Fitness home"
          onClick={() => setOpen(false)}
        >
          <MobileLogo />
        </Link>
        <button
          ref={toggle}
          type="button"
          className={styles.toggle}
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-controls="primary-navigation"
          onClick={() => setOpen(!open)}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true" focusable="false">
            <path d={open ? "M6 6L18 18M18 6L6 18" : "M3 6H21M3 12H21M3 18H21"} />
          </svg>
        </button>
        <nav
          id="primary-navigation"
          aria-label="Main navigation"
          className={`${styles.navigation} ${open ? styles.open : ""}`}
        >
          <ul className={styles.links}>
            {links.map(([label, href]) => (
              <li key={href}>
                <a
                  href={href}
                  aria-current={
                    active === href
                      ? href.includes("#")
                        ? "location"
                        : "page"
                      : undefined
                  }
                  onClick={() => setOpen(false)}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <Link
            to="/#contact"
            className={styles.join}
            onClick={() => setOpen(false)}
          >
            Join the club <span aria-hidden="true">→</span>
          </Link>
        </nav>
      </div>
    </header>
  )
}
